import type { IElectiveCategoryByIDStates, IElectiveCategoryStates } from '../../../interface/state/IElectiveCategory';
import { electiveCategoryType } from '../../types';
import { createAPI, deleteByIdAPI, getAPI, getByIdAPI, getByNameAPI, updateAPI } from '../api-utils';

export const create = createAPI<undefined, { name: string }>({
	actionType: electiveCategoryType.create,
	url: '/api/v1/ElectiveCategory',
});

export const get = getAPI<IElectiveCategoryStates>({
	actionType: electiveCategoryType.get,
	url: '/api/v1/ElectiveCategory',
	type: 'command',
});

export const getByID = getByIdAPI<IElectiveCategoryByIDStates>({
	actionType: electiveCategoryType.getByID,
	url: '/api/v1/ElectiveCategory',
});

export const getByName = getByNameAPI({
	actionType: electiveCategoryType.getByName,
	url: '/api/v1/ElectiveCategory/name',
});

export const update = updateAPI<undefined, { id: string; name: string }>({
	actionType: electiveCategoryType.update,
	url: '/api/v1/ElectiveCategory/update',
});

export const deleteById = deleteByIdAPI({
	actionType: electiveCategoryType.deleteById,
	url: '/api/v1/ElectiveCategory/delete',
});
